// AUTO-GENERATED from Shopier urunler.xlsx — do not edit by hand
// To regenerate, run scripts/import_shopier.py

export const CATEGORIES = [
  { slug: "kolyeler", title: "Kolyeler", desc: "Zarif zincirler, anlamlı dokunuşlar.", image: "/shopier/p-3.jpeg", count: 54 },
  { slug: "kupeler", title: "Küpeler", desc: "Minimal halkalardan ışıltılı detaylara.", image: "/shopier/p-33.jpeg", count: 89 },
  { slug: "bileklikler", title: "Bileklikler", desc: "Bileğinizde sade bir imza.", image: "/shopier/p-2.jpeg", count: 50 },
  { slug: "yuzukler", title: "Yüzükler", desc: "Parmağınızda zamansız bir hatıra.", image: "/shopier/p-82.jpeg", count: 25 },
  { slug: "halhallar", title: "Halhallar", desc: "Her adımda hafif bir ışıltı.", image: "/shopier/p-22.jpeg", count: 10 },
];

export const FEATURED_IDS = [
  "nl-002",
  "nl-003",
  "nl-004",
  "nl-010",
  "nl-022",
  "nl-023",
  "nl-033",
  "nl-039",
];

export const PRODUCTS = [
  {
    id: "nl-002",
    name: "İp Bileklik Yeşil",
    category: "bileklikler",
    image: "/shopier/p-2.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48306109",
    price: "280,00 ₺",
  },
  {
    id: "nl-003",
    name: "VİP 14 K Kolye (45+5 cm)",
    category: "kolyeler",
    image: "/shopier/p-3.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305620",
    price: "480,00 ₺",
  },
  {
    id: "nl-004",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-4.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305599",
    price: "280,00 ₺",
  },
  {
    id: "nl-005",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-5.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305591",
    price: "280,00 ₺",
  },
  {
    id: "nl-006",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-6.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305584",
    price: "280,00 ₺",
  },
  {
    id: "nl-007",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-7.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305565",
    price: "280,00 ₺",
  },
  {
    id: "nl-008",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-8.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305549",
    price: "280,00 ₺",
  },
  {
    id: "nl-009",
    name: "İP BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-9.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305525",
    price: "280,00 ₺",
  },
  {
    id: "nl-010",
    name: "VİP 14K KOLYE 60 cm",
    category: "kolyeler",
    image: "/shopier/p-10.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305276",
    price: "350,00 ₺",
  },
  {
    id: "nl-011",
    name: "VİP 14K KOLYE 45 cm",
    category: "kolyeler",
    image: "/shopier/p-11.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305260",
    price: "300,00 ₺",
  },
  {
    id: "nl-012",
    name: "VİP KOLYE 50 cm",
    category: "kolyeler",
    image: "/shopier/p-12.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305209",
    price: "320,00 ₺",
  },
  {
    id: "nl-013",
    name: "VİP 14K KOLYE 45 cm",
    category: "kolyeler",
    image: "/shopier/p-13.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305175",
    price: "280,00 ₺",
  },
  {
    id: "nl-014",
    name: "VİP 14K KOLYE 50 cm",
    category: "kolyeler",
    image: "/shopier/p-14.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305126",
    price: "350,00 ₺",
  },
  {
    id: "nl-015",
    name: "VİP KOLYE 50 cm",
    category: "kolyeler",
    image: "/shopier/p-15.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305073",
    price: "300,00 ₺",
  },
  {
    id: "nl-016",
    name: "VİP KOLYE 14K",
    category: "kolyeler",
    image: "/shopier/p-16.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48305026",
    price: "475,00 ₺",
  },
  {
    id: "nl-017",
    name: "VİP 14K KOLYE",
    category: "kolyeler",
    image: "/shopier/p-17.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48304963",
    price: "450,00 ₺",
  },
  {
    id: "nl-018",
    name: "XUPING KOLYE TOPLU",
    category: "kolyeler",
    image: "/shopier/p-18.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48111139",
    price: "280,00 ₺",
  },
  {
    id: "nl-019",
    name: "XUPING KOLYE",
    category: "kolyeler",
    image: "/shopier/p-19.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48111097",
    price: "280,00 ₺",
  },
  {
    id: "nl-020",
    name: "XUPING KOLYE 50 cm",
    category: "kolyeler",
    image: "/shopier/p-20.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48111017",
    price: "300,00 ₺",
  },
  {
    id: "nl-021",
    name: "XUPING KOLYE 45 cm",
    category: "kolyeler",
    image: "/shopier/p-21.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110855",
    price: "280,00 ₺",
  },
  {
    id: "nl-022",
    name: "HALHAL",
    category: "halhallar",
    image: "/shopier/p-22.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110745",
    price: "280,00 ₺",
  },
  {
    id: "nl-023",
    name: "HALHAL",
    category: "halhallar",
    image: "/shopier/p-23.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110707",
    price: "280,00 ₺",
  },
  {
    id: "nl-024",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-24.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110658",
    price: "300,00 ₺",
  },
  {
    id: "nl-025",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-25.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110629",
    price: "400,00 ₺",
  },
  {
    id: "nl-026",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-26.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110595",
    price: null,
  },
  {
    id: "nl-027",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-27.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110562",
    price: null,
  },
  {
    id: "nl-028",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-28.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110543",
    price: null,
  },
  {
    id: "nl-029",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-29.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110481",
    price: null,
  },
  {
    id: "nl-030",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-30.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110425",
    price: null,
  },
  {
    id: "nl-031",
    name: "ÇELiK BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-31.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110361",
    price: null,
  },
  {
    id: "nl-032",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-32.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48110321",
    price: null,
  },
  {
    id: "nl-033",
    name: "Çelik Nazar Boncuklu Küpe",
    category: "kupeler",
    image: "/shopier/p-33.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108746",
    price: null,
  },
  {
    id: "nl-034",
    name: "Özel Seri Kolye Ucu",
    category: "kolyeler",
    image: "/shopier/p-34.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108714",
    price: null,
  },
  {
    id: "nl-035",
    name: "Özel Seri Kolye Ucu",
    category: "kolyeler",
    image: "/shopier/p-35.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108678",
    price: null,
  },
  {
    id: "nl-036",
    name: "Özel Seri Kolye Ucu 14 K",
    category: "kolyeler",
    image: "/shopier/p-36.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108661",
    price: null,
  },
  {
    id: "nl-037",
    name: "Özel Seri Kolye Ucu 14 K",
    category: "kolyeler",
    image: "/shopier/p-37.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108626",
    price: null,
  },
  {
    id: "nl-038",
    name: "Özel Seri Kolye Ucu 14 K",
    category: "kolyeler",
    image: "/shopier/p-38.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48108603",
    price: null,
  },
  {
    id: "nl-039",
    name: "BİJUTERİ KÜPE",
    category: "kupeler",
    image: "/shopier/p-39.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48097756",
    price: null,
  },
  {
    id: "nl-040",
    name: "BUJİTERİ KÜPE",
    category: "kupeler",
    image: "/shopier/p-40.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48097690",
    price: null,
  },
  {
    id: "nl-041",
    name: "PAPATYA HASIR KÜPE",
    category: "kupeler",
    image: "/shopier/p-41.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48097457",
    price: null,
  },
  {
    id: "nl-042",
    name: "DENİZ YILDIZI HASIR KÜPE",
    category: "kupeler",
    image: "/shopier/p-42.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096795",
    price: null,
  },
  {
    id: "nl-043",
    name: "YAKEMIYOU KÜPE SETİ 6 lı",
    category: "kupeler",
    image: "/shopier/p-43.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096656",
    price: null,
  },
  {
    id: "nl-044",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-44.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096564",
    price: null,
  },
  {
    id: "nl-045",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-45.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096336",
    price: null,
  },
  {
    id: "nl-046",
    name: "XUPİNG KÜPE",
    category: "kupeler",
    image: "/shopier/p-46.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096313",
    price: null,
  },
  {
    id: "nl-047",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-47.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096205",
    price: null,
  },
  {
    id: "nl-048",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-48.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48096048",
    price: null,
  },
  {
    id: "nl-049",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-49.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48095880",
    price: null,
  },
  {
    id: "nl-050",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-50.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48095772",
    price: null,
  },
  {
    id: "nl-051",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-51.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48095685",
    price: null,
  },
  {
    id: "nl-052",
    name: "XUPING KÜPE",
    category: "kupeler",
    image: "/shopier/p-52.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/48095630",
    price: null,
  },
  {
    id: "nl-053",
    name: "XUPİNG BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-53.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47947973",
    price: null,
  },
  {
    id: "nl-054",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-54.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362419",
    price: null,
  },
  {
    id: "nl-055",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-55.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362392",
    price: null,
  },
  {
    id: "nl-056",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-56.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362364",
    price: null,
  },
  {
    id: "nl-057",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-57.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362259",
    price: null,
  },
  {
    id: "nl-058",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-58.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362162",
    price: null,
  },
  {
    id: "nl-059",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-59.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362124",
    price: null,
  },
  {
    id: "nl-060",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-60.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362099",
    price: null,
  },
  {
    id: "nl-061",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-61.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362073",
    price: null,
  },
  {
    id: "nl-062",
    name: "Xuping Vip 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-62.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47362002",
    price: null,
  },
  {
    id: "nl-063",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-63.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361694",
    price: null,
  },
  {
    id: "nl-064",
    name: "Xuping Vip Seri 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-64.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361412",
    price: null,
  },
  {
    id: "nl-065",
    name: "Xuping Vip Seri 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-65.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361341",
    price: null,
  },
  {
    id: "nl-066",
    name: "Xuping Vip Seri 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-66.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361308",
    price: null,
  },
  {
    id: "nl-067",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-67.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361233",
    price: null,
  },
  {
    id: "nl-068",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-68.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361206",
    price: null,
  },
  {
    id: "nl-069",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-69.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361183",
    price: null,
  },
  {
    id: "nl-070",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-70.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361158",
    price: null,
  },
  {
    id: "nl-071",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-71.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361135",
    price: null,
  },
  {
    id: "nl-072",
    name: "Xuping 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-72.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361101",
    price: null,
  },
  {
    id: "nl-073",
    name: "Xuping 14K Vip Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-73.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361060",
    price: null,
  },
  {
    id: "nl-074",
    name: "Xuping Vip 14K Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-74.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47361030",
    price: null,
  },
  {
    id: "nl-075",
    name: "Xuping Vip 14k Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-75.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47360991",
    price: null,
  },
  {
    id: "nl-076",
    name: "Xuping 14K Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-76.jpg",
    link: "https://www.shopier.com/novalandaksesuar/47360954",
    price: null,
  },
  {
    id: "nl-077",
    name: "Özel Seri Şahmeran",
    category: "bileklikler",
    image: "/shopier/p-77.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47360677",
    price: null,
  },
  {
    id: "nl-078",
    name: "Özel Seri Şahmeran",
    category: "bileklikler",
    image: "/shopier/p-78.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47360471",
    price: null,
  },
  {
    id: "nl-079",
    name: "Özel Seri Bileklik",
    category: "bileklikler",
    image: "/shopier/p-79.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47359892",
    price: null,
  },
  {
    id: "nl-080",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-80.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47359785",
    price: null,
  },
  {
    id: "nl-081",
    name: "Özel Seri Bileklik",
    category: "bileklikler",
    image: "/shopier/p-81.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47359688",
    price: null,
  },
  {
    id: "nl-082",
    name: "Özel Seri Yüzük",
    category: "yuzukler",
    image: "/shopier/p-82.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47359346",
    price: null,
  },
  {
    id: "nl-083",
    name: "Özel Seri Yüzük",
    category: "yuzukler",
    image: "/shopier/p-83.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47359135",
    price: null,
  },
  {
    id: "nl-084",
    name: "XUPING KOLYE",
    category: "kolyeler",
    image: "/shopier/p-84.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358841",
    price: null,
  },
  {
    id: "nl-085",
    name: "XUPING KOLYE",
    category: "kolyeler",
    image: "/shopier/p-85.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358657",
    price: null,
  },
  {
    id: "nl-086",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-86.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358485",
    price: null,
  },
  {
    id: "nl-087",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-87.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358297",
    price: null,
  },
  {
    id: "nl-088",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-88.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358203",
    price: null,
  },
  {
    id: "nl-089",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-89.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358074",
    price: null,
  },
  {
    id: "nl-090",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-90.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47358025",
    price: null,
  },
  {
    id: "nl-091",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-91.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357971",
    price: null,
  },
  {
    id: "nl-092",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-92.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357868",
    price: null,
  },
  {
    id: "nl-093",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-93.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357834",
    price: null,
  },
  {
    id: "nl-094",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-94.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357795",
    price: null,
  },
  {
    id: "nl-095",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-95.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357754",
    price: null,
  },
  {
    id: "nl-096",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-96.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357715",
    price: null,
  },
  {
    id: "nl-097",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-97.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357606",
    price: null,
  },
  {
    id: "nl-098",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-98.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357546",
    price: null,
  },
  {
    id: "nl-099",
    name: "XUPING BİLEKLİK",
    category: "bileklikler",
    image: "/shopier/p-99.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/47357480",
    price: null,
  },
  {
    id: "nl-100",
    name: "Özel Seri VIP Bileklik",
    category: "bileklikler",
    image: "/shopier/p-100.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46262514",
    price: null,
  },
  {
    id: "nl-101",
    name: "Özel Seri VIP Bileklik",
    category: "bileklikler",
    image: "/shopier/p-101.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46262474",
    price: null,
  },
  {
    id: "nl-102",
    name: "Özel Seri VIP Bileklik",
    category: "bileklikler",
    image: "/shopier/p-102.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46262433",
    price: null,
  },
  {
    id: "nl-103",
    name: "Özel Seri VIP Bileklik",
    category: "bileklikler",
    image: "/shopier/p-103.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46262387",
    price: null,
  },
  {
    id: "nl-104",
    name: "Özel Seri VİP Kolye 70 cm",
    category: "kolyeler",
    image: "/shopier/p-104.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46261531",
    price: null,
  },
  {
    id: "nl-105",
    name: "Özel Seri VİP Kolye 60 cm (ince top)",
    category: "kolyeler",
    image: "/shopier/p-105.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261521",
    price: null,
  },
  {
    id: "nl-106",
    name: "Özel Seri VIP Kolye",
    category: "kolyeler",
    image: "/shopier/p-106.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261473",
    price: null,
  },
  {
    id: "nl-107",
    name: "Çelik Kolye",
    category: "kolyeler",
    image: "/shopier/p-107.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261453",
    price: null,
  },
  {
    id: "nl-108",
    name: "Özel Seri VIP Kolye",
    category: "kolyeler",
    image: "/shopier/p-108.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261430",
    price: null,
  },
  {
    id: "nl-109",
    name: "Özel Seri VIP Kolye",
    category: "kolyeler",
    image: "/shopier/p-109.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261393",
    price: null,
  },
  {
    id: "nl-110",
    name: "Özel Seri VIP Kolye Bronz",
    category: "kolyeler",
    image: "/shopier/p-110.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261371",
    price: null,
  },
  {
    id: "nl-111",
    name: "Özel Seri VİP Su yolu dönmeyen",
    category: "kolyeler",
    image: "/shopier/p-111.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261131",
    price: null,
  },
  {
    id: "nl-112",
    name: "Özel Seri VIP Kolye bronz",
    category: "kolyeler",
    image: "/shopier/p-112.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261085",
    price: null,
  },
  {
    id: "nl-113",
    name: "Özel Seri VİP Kolye",
    category: "kolyeler",
    image: "/shopier/p-113.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261050",
    price: null,
  },
  {
    id: "nl-114",
    name: "Özel Seri VİP Kolye",
    category: "kolyeler",
    image: "/shopier/p-114.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46261030",
    price: null,
  },
  {
    id: "nl-115",
    name: "Özel Seri VIP Kolye",
    category: "kolyeler",
    image: "/shopier/p-115.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46260991",
    price: null,
  },
  {
    id: "nl-116",
    name: "Özel Seri VIP Kolye",
    category: "kolyeler",
    image: "/shopier/p-116.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46260773",
    price: null,
  },
  {
    id: "nl-117",
    name: "Çelik Uzun Y  Kolye",
    category: "kolyeler",
    image: "/shopier/p-117.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46260712",
    price: null,
  },
  {
    id: "nl-118",
    name: "Çelik Uzun Y Kolye",
    category: "kolyeler",
    image: "/shopier/p-118.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46260685",
    price: null,
  },
  {
    id: "nl-119",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-119.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46259762",
    price: null,
  },
  {
    id: "nl-120",
    name: "Özel Seri VIP Halhal",
    category: "halhallar",
    image: "/shopier/p-120.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249506",
    price: null,
  },
  {
    id: "nl-121",
    name: "Özel Seri VIP Halhal",
    category: "halhallar",
    image: "/shopier/p-121.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249272",
    price: null,
  },
  {
    id: "nl-122",
    name: "Özel Seri VIP Halhal",
    category: "halhallar",
    image: "/shopier/p-122.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249230",
    price: null,
  },
  {
    id: "nl-123",
    name: "Özel Seri VIP Halhal",
    category: "halhallar",
    image: "/shopier/p-123.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249212",
    price: null,
  },
  {
    id: "nl-124",
    name: "Kalpli Halhal",
    category: "halhallar",
    image: "/shopier/p-124.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249103",
    price: null,
  },
  {
    id: "nl-125",
    name: "Özel Seri VIP Halhal",
    category: "halhallar",
    image: "/shopier/p-125.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249073",
    price: null,
  },
  {
    id: "nl-126",
    name: "Özel Seri VİP Halhal",
    category: "halhallar",
    image: "/shopier/p-126.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46249009",
    price: null,
  },
  {
    id: "nl-127",
    name: "Dorikalı Halhal",
    category: "halhallar",
    image: "/shopier/p-127.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46248508",
    price: null,
  },
  {
    id: "nl-128",
    name: "XUPİNG Küpe",
    category: "kupeler",
    image: "/shopier/p-128.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46248297",
    price: null,
  },
  {
    id: "nl-129",
    name: "XUPİNG Küpe",
    category: "kupeler",
    image: "/shopier/p-129.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46248211",
    price: null,
  },
  {
    id: "nl-130",
    name: "XUPİNG Küpe",
    category: "kupeler",
    image: "/shopier/p-130.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46247948",
    price: null,
  },
  {
    id: "nl-131",
    name: "Özel Seri VİP Küpe Büyük Boy",
    category: "kupeler",
    image: "/shopier/p-131.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46228560",
    price: null,
  },
  {
    id: "nl-132",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-132.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46228440",
    price: null,
  },
  {
    id: "nl-133",
    name: "Özel Seri Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-133.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227535",
    price: null,
  },
  {
    id: "nl-134",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-134.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227436",
    price: null,
  },
  {
    id: "nl-135",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-135.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227386",
    price: null,
  },
  {
    id: "nl-136",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-136.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227360",
    price: null,
  },
  {
    id: "nl-137",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-137.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227292",
    price: null,
  },
  {
    id: "nl-138",
    name: "VİP ÇELİK SERÇE PARMAK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-138.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227260",
    price: null,
  },
  {
    id: "nl-139",
    name: "VİP ÇELİK SERÇE PARMAK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-139.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227251",
    price: null,
  },
  {
    id: "nl-140",
    name: "VİP ÇELİK SERÇE PARMAK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-140.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227237",
    price: null,
  },
  {
    id: "nl-141",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-141.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227177",
    price: null,
  },
  {
    id: "nl-142",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-142.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227162",
    price: null,
  },
  {
    id: "nl-143",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-143.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227119",
    price: null,
  },
  {
    id: "nl-144",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-144.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227101",
    price: null,
  },
  {
    id: "nl-145",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-145.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227089",
    price: null,
  },
  {
    id: "nl-146",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-146.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227067",
    price: null,
  },
  {
    id: "nl-147",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-147.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227032",
    price: null,
  },
  {
    id: "nl-148",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-148.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46227017",
    price: null,
  },
  {
    id: "nl-149",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-149.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46227004",
    price: null,
  },
  {
    id: "nl-150",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-150.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46226963",
    price: null,
  },
  {
    id: "nl-151",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-151.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46226948",
    price: null,
  },
  {
    id: "nl-152",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-152.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226947",
    price: null,
  },
  {
    id: "nl-153",
    name: "VİP ÇELİK YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-153.jpg",
    link: "https://www.shopier.com/novalandaksesuar/46226910",
    price: null,
  },
  {
    id: "nl-154",
    name: "Özel Seri VİP Küpe",
    category: "kupeler",
    image: "/shopier/p-154.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226848",
    price: null,
  },
  {
    id: "nl-155",
    name: "Özel Seri Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-155.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226753",
    price: null,
  },
  {
    id: "nl-156",
    name: "Özel Seri Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-156.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226717",
    price: null,
  },
  {
    id: "nl-157",
    name: "Özel Seri Çelik Küpe Kahverengi",
    category: "kupeler",
    image: "/shopier/p-157.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226649",
    price: null,
  },
  {
    id: "nl-158",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-158.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226599",
    price: null,
  },
  {
    id: "nl-159",
    name: "Çelik Halka Küpe",
    category: "kupeler",
    image: "/shopier/p-159.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/46226524",
    price: null,
  },
  {
    id: "nl-160",
    name: "Xuping bileklik",
    category: "bileklikler",
    image: "/shopier/p-160.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45985472",
    price: null,
  },
  {
    id: "nl-161",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-161.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45700584",
    price: null,
  },
  {
    id: "nl-162",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-162.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45700516",
    price: null,
  },
  {
    id: "nl-163",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-163.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45700449",
    price: null,
  },
  {
    id: "nl-164",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-164.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45700392",
    price: null,
  },
  {
    id: "nl-165",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-165.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45700316",
    price: null,
  },
  {
    id: "nl-166",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-166.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45695211",
    price: null,
  },
  {
    id: "nl-167",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-167.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45695157",
    price: null,
  },
  {
    id: "nl-168",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-168.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45695092",
    price: null,
  },
  {
    id: "nl-169",
    name: "Özel Seri Vip Kıkırdak Küpeler",
    category: "kupeler",
    image: "/shopier/p-169.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45694644",
    price: null,
  },
  {
    id: "nl-170",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-170.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45694432",
    price: null,
  },
  {
    id: "nl-171",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-171.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45693990",
    price: null,
  },
  {
    id: "nl-172",
    name: "VİP YÜZÜK",
    category: "yuzukler",
    image: "/shopier/p-172.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45693938",
    price: null,
  },
  {
    id: "nl-173",
    name: "Xuping Bileklik",
    category: "bileklikler",
    image: "/shopier/p-173.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45686475",
    price: null,
  },
  {
    id: "nl-174",
    name: "Xuping Bİleklik",
    category: "bileklikler",
    image: "/shopier/p-174.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45686421",
    price: null,
  },
  {
    id: "nl-175",
    name: "Xuping Bileklik",
    category: "bileklikler",
    image: "/shopier/p-175.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45686176",
    price: null,
  },
  {
    id: "nl-176",
    name: "Xuping Bileklik",
    category: "bileklikler",
    image: "/shopier/p-176.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45685998",
    price: null,
  },
  {
    id: "nl-177",
    name: "Xuping Bileklik Van Cleef",
    category: "bileklikler",
    image: "/shopier/p-177.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45685976",
    price: null,
  },
  {
    id: "nl-178",
    name: "Xuping Van Cleef Bileklik",
    category: "bileklikler",
    image: "/shopier/p-178.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45685927",
    price: null,
  },
  {
    id: "nl-179",
    name: "Çelik Piercing",
    category: "kupeler",
    image: "/shopier/p-179.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685412",
    price: null,
  },
  {
    id: "nl-180",
    name: "Çelik Piercing",
    category: "kupeler",
    image: "/shopier/p-180.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685345",
    price: null,
  },
  {
    id: "nl-181",
    name: "Çelik Piercing",
    category: "kupeler",
    image: "/shopier/p-181.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685325",
    price: null,
  },
  {
    id: "nl-182",
    name: "Çelik piercing",
    category: "kupeler",
    image: "/shopier/p-182.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685265",
    price: null,
  },
  {
    id: "nl-183",
    name: "Özel Seri Şahmeran",
    category: "bileklikler",
    image: "/shopier/p-183.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685059",
    price: null,
  },
  {
    id: "nl-184",
    name: "Özel Seri Şahmeran",
    category: "bileklikler",
    image: "/shopier/p-184.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45685015",
    price: null,
  },
  {
    id: "nl-185",
    name: "Özel Seri Şahmeran",
    category: "bileklikler",
    image: "/shopier/p-185.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45684927",
    price: null,
  },
  {
    id: "nl-186",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-186.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45684602",
    price: null,
  },
  {
    id: "nl-187",
    name: "Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-187.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45684406",
    price: null,
  },
  {
    id: "nl-188",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-188.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45684278",
    price: null,
  },
  {
    id: "nl-189",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-189.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45684089",
    price: null,
  },
  {
    id: "nl-190",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-190.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683923",
    price: null,
  },
  {
    id: "nl-191",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-191.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683859",
    price: null,
  },
  {
    id: "nl-192",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-192.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683835",
    price: null,
  },
  {
    id: "nl-193",
    name: "Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-193.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683703",
    price: null,
  },
  {
    id: "nl-194",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-194.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683653",
    price: null,
  },
  {
    id: "nl-195",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-195.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683544",
    price: null,
  },
  {
    id: "nl-196",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-196.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683447",
    price: null,
  },
  {
    id: "nl-197",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-197.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683413",
    price: null,
  },
  {
    id: "nl-198",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-198.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683314",
    price: null,
  },
  {
    id: "nl-199",
    name: "Çelik küpe",
    category: "kupeler",
    image: "/shopier/p-199.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683222",
    price: null,
  },
  {
    id: "nl-200",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-200.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45683094",
    price: null,
  },
  {
    id: "nl-201",
    name: "Çelik küpe",
    category: "kupeler",
    image: "/shopier/p-201.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45683041",
    price: null,
  },
  {
    id: "nl-202",
    name: "VİP KOLYE Van Cleef",
    category: "kolyeler",
    image: "/shopier/p-202.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45668653",
    price: null,
  },
  {
    id: "nl-203",
    name: "VİP KOLYE(45 CM)",
    category: "kolyeler",
    image: "/shopier/p-203.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45668570",
    price: null,
  },
  {
    id: "nl-204",
    name: "VİP ZİNCİR (50 CM)",
    category: "kolyeler",
    image: "/shopier/p-204.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45668490",
    price: null,
  },
  {
    id: "nl-205",
    name: "VİP KOLYE( 50 CM)",
    category: "kolyeler",
    image: "/shopier/p-205.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45668178",
    price: null,
  },
  {
    id: "nl-206",
    name: "VİP KOLYE( 45 CM)",
    category: "kolyeler",
    image: "/shopier/p-206.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45668081",
    price: null,
  },
  {
    id: "nl-207",
    name: "VİP KOLYE( 60 CM)",
    category: "kolyeler",
    image: "/shopier/p-207.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45667987",
    price: null,
  },
  {
    id: "nl-208",
    name: "VİP KOLYE",
    category: "kolyeler",
    image: "/shopier/p-208.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45667915",
    price: null,
  },
  {
    id: "nl-209",
    name: "VİP KOLYE( 50 CM)",
    category: "kolyeler",
    image: "/shopier/p-209.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667852",
    price: null,
  },
  {
    id: "nl-210",
    name: "VİP KOLYE( 50 CM)",
    category: "kolyeler",
    image: "/shopier/p-210.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667707",
    price: null,
  },
  {
    id: "nl-211",
    name: "Özel Seri Küpe Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-211.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667641",
    price: null,
  },
  {
    id: "nl-212",
    name: "VİP KOLYE(50 CM)",
    category: "kolyeler",
    image: "/shopier/p-212.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667606",
    price: null,
  },
  {
    id: "nl-213",
    name: "VİP KOLYE( 60 CM)",
    category: "kolyeler",
    image: "/shopier/p-213.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667483",
    price: null,
  },
  {
    id: "nl-214",
    name: "Özel Seri Vip Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-214.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667474",
    price: null,
  },
  {
    id: "nl-215",
    name: "Özel Seri Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-215.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667422",
    price: null,
  },
  {
    id: "nl-216",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-216.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667358",
    price: null,
  },
  {
    id: "nl-217",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-217.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667084",
    price: null,
  },
  {
    id: "nl-218",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-218.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45667026",
    price: null,
  },
  {
    id: "nl-219",
    name: "Özel Seri Küpe",
    category: "kupeler",
    image: "/shopier/p-219.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666959",
    price: null,
  },
  {
    id: "nl-220",
    name: "VİP ZiNCiR KOLYE (60+5CM)",
    category: "kolyeler",
    image: "/shopier/p-220.jpeg",
    link: "https://www.shopier.com/novalandaksesuar/45666922",
    price: null,
  },
  {
    id: "nl-221",
    name: "Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-221.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666835",
    price: null,
  },
  {
    id: "nl-222",
    name: "Çelik Küpe",
    category: "kupeler",
    image: "/shopier/p-222.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666810",
    price: null,
  },
  {
    id: "nl-223",
    name: "VİP KOLYE (50 CM)",
    category: "kolyeler",
    image: "/shopier/p-223.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666593",
    price: null,
  },
  {
    id: "nl-224",
    name: "VİP KOLYE(50 cm)",
    category: "kolyeler",
    image: "/shopier/p-224.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666394",
    price: null,
  },
  {
    id: "nl-225",
    name: "VİP KOLYE(45 cm)",
    category: "kolyeler",
    image: "/shopier/p-225.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666210",
    price: null,
  },
  {
    id: "nl-226",
    name: "VİP KOLYE(45 cm) Van Cleef",
    category: "kolyeler",
    image: "/shopier/p-226.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45666119",
    price: null,
  },
  {
    id: "nl-227",
    name: "Vİp Kolye (55 cm)",
    category: "kolyeler",
    image: "/shopier/p-227.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45665889",
    price: null,
  },
  {
    id: "nl-228",
    name: "Vip Kolye (45cm)",
    category: "kolyeler",
    image: "/shopier/p-228.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45665855",
    price: null,
  },
  {
    id: "nl-229",
    name: "Vip Kolye (45cm)",
    category: "kolyeler",
    image: "/shopier/p-229.jpg",
    link: "https://www.shopier.com/novalandaksesuar/45665813",
    price: null,
  },
];
